// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'
Vue.prototype.$axios = axios;
Vue.use(less)
Vue.use(ElementUI)
Vue.use(BaiduMap, {
  ak: 'D0t9xpANwt0fhR3TzmQxOwbqIMNfSurC'
})
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js